
import {
  all,
  put,
  takeLatest,
  select,
} from 'redux-saga/effects';
import * as actions from './actions';
import * as types from './types';

function* init() {
  yield all([
    put(actions.resetChart()),
    put(actions.initZoomRequest()),
    put(actions.initBrushRequest()),
    put(actions.initBrushCompareRequest()),
    put(actions.initSecondaryRequest()),
    put(actions.initSecondaryCompareRequest()),
  ]);
}

function* watchInit() {
  yield takeLatest([
    types.INIT,
  ], init);
}

export default [
  watchInit,
];
